import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import {connect, setStore} from "trim-redux";
import {InputAdornment, MenuItem, TextField} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {isAdmin, rolesWithName} from "../../../../config/Permissions";
import {useNavigate} from "react-router-dom";

import {useParams} from "react-router";
import {updateRedux} from "../../../../config/Security";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import MobileField from "../../../components/elements/fields/MobileField";
import moment from "moment";
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import PassField from "../../../components/elements/fields/PassField";
import PasswordSkeleton from "../../../components/loaders/PasswordSkeleton";
import {removeLocalStorages} from "../../../../config/values";
import {Check} from "lucide-react";

const MakeUser = (props) => {
    const { classes } = props;
    const navigation = useNavigate();

    const [fields, setFields] = useState({
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
    });
    let id = props.user.id;
    const [errors, setErrors] = useState({});
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [hasPass, setHasPass] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/users/get/${id}`,config)
            .then(response => {
                if(!!response.data.password){
                    setHasPass(true);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        // Fetch match data when component mounts
        loadData();
    }, [id]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};
        if(!!hasPass && !props.reset){
            // Password
            if (validator.isEmpty(fields.old_password)) {
                formIsValid = false;
                newErrors['old_password'] = t('emptyField');
            } else if (fields.old_password.length < 5) {
                formIsValid = false;
                newErrors['old_password'] = t('weakPassword');
            }
        }
        // Password
        if (validator.isEmpty(fields.new_password)) {
            formIsValid = false;
            newErrors['new_password'] = t('emptyField');
        } else if (fields.new_password.length < 5) {
            formIsValid = false;
            newErrors['new_password'] = t('weakPassword');
        }
        if(fields.new_password !== fields.new_password_confirmation){
            formIsValid = false;
            newErrors['new_password_confirmation'] = t('passConfirmationError');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };
    const handleLogout = () => {
        removeLocalStorages()
        setStore({
            isAuth: false,
            user: null,
        });
        navigation('/login')
    };
    const handleRequest = async () => {

        const data = new FormData();

        data.append('user_id', id);
        data.append('reset', !!props.reset ? 1 : 0);
        if(!!hasPass){
            data.append('old_password', fields.old_password);
        }
        data.append('new_password', fields.new_password);
        data.append('new_password_confirmation', fields.new_password_confirmation);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/users/makePassword`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            setFields({
                old_password: '',
                new_password: '',
                new_password_confirmation: '',

            });
            loadData();
            updateRedux();
            if(!!props.reset){
                navigation('/');
            }

        } catch (error) {
            console.error(error.response);
            if(error.response.status === 402 && !!props.reset){
                enqueueSnackbar(t('resetTimeGone'), { variant: 'error' });
                handleLogout();
            }else{
                enqueueSnackbar(t('currentPassWrong'), { variant: 'error' });
            }
            setSubmitLoading(false);

        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    if (loading) {
        return <PasswordSkeleton />;
    }

    return (
        <Grid container spacing={2}>
            <CssBaseline />
            {
                (!!hasPass && !props.reset) &&
                <PassField
                    fullWidth
                    variant="outlined"
                    name="old_password"
                    label={t('old_password')}
                    onChange={handleChange}
                    error={!!errors['old_password']}
                    helperText={errors['old_password']}
                />
            }
            <PassField
                fullWidth
                variant="outlined"
                name="new_password"
                label={t('password')}
                onChange={handleChange}
                error={!!errors['new_password']}
                helperText={errors['new_password']}
            />
            <PassField
                fullWidth
                variant="outlined"
                name="new_password_confirmation"
                label={t('password_confirmation')}
                onChange={handleChange}
                error={!!errors['new_password_confirmation']}
                helperText={errors['new_password_confirmation']}
            />
            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    startIcon={<Check/>}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>
        </Grid>

    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakeUser));
